
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        iconclass: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: null,
        },
        fill: {
            type: String,
            default: null,
        },
        align: {
            type: [Boolean, String],
            default: false,
        },
        stroke: {
            type: Boolean,
            default: false,
        },
        strokeOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        /** @return {string} */
        fontSize() {
            return this.size ? `font-size-${this.size}` : '';
        },
        /** @return {string | undefined} */
        textAlign() {
            if (!this.align) {
                return;
            }

            if (this.align === true) {
                return this.align && this.size ? `text-align-${this.size}` : '';
            }

            return `text-align-${this.align}`;
        },
        /** @return {string} */
        iconHtml() {
            if (!this.icon) {
                return '';
            }

            if (!this.icon.startsWith('<svg ')) {
                return this.icon;
            }

            if (!this.title) {
                return this.icon.replace('>', 'focusable="false">');
            }

            return this.icon.replace('>', `role="img" focusable="false" aria-label="${this.escapeHtml(this.title)}">`);
        },
        /** @return {Record<string, string>} */
        iconFill() {
            return this.fill ? { color: this.fill } : {};
        },
        /** @return {string?} */
        iconStroke() {
            if (!this.strokeOnly && !this.stroke) {
                return null;
            }

            return this.stroke ? 'tidal-icon--stroke' : 'tidal-icon--stroke-only';
        },
    },
    methods: {
        /** @param {string} text */
        escapeHtml(text) {
            return text.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll('\'', '&#039;');
        },
    },
};
